const generateMarkdownFaqData = (markdownAst) => {
  let markdown_faq = {}
  const node_types = {
    paragraph: { open: "<p>", close: "</p>" },
    list: { open: "<ul>", close: "</ul>" },
    listItem: { open: "<li>", close: "</li>" },
    text: { open: "", close: "" },
    link: { open: "", close: "" },
    strong: { open: "<strong>", close: "</strong>" },
  }

  markdownAst.children?.forEach((item, index) => {
    if (
      item.type === "heading" &&
      item.children?.[item.children?.length - 1]?.value?.slice(-1) === "?"
    ) {
      const parseAstNode = (answer, node) => {
        answer = answer.concat(node_types[node.type]?.open || "")
        if (!!node.value) {
          return answer.concat(node.value)
        } else {
          return (node.children || [])
            .reduce(
              (childAnswer, childNode) => parseAstNode(childAnswer, childNode),
              answer
            )
            .concat(node_types[node.type]?.close || "")
        }
      }

      const valid_answer_node = markdownAst.children
        .slice(index + 1)
        ?.find(
          (node) => node.type !== "jsx" && node.children?.[0]?.type !== "image"
        )

      const faq_question = parseAstNode("", item)

      let faq_answer = !!valid_answer_node
        ? parseAstNode("", valid_answer_node)
        : null

      Object.assign(markdown_faq, {
        [faq_question]: faq_answer,
      })
    }
  })

  return markdown_faq
}

module.exports = generateMarkdownFaqData
